import * as React from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';
import { useMount } from '@uifabric/portal-ux/lib/hooks/useMount';
import { MessageBar, MessageBarType } from '@fluentui/react/lib/MessageBar';
import { ContactPreferenceFooter } from './ContactPreferenceFooter';
import { ContactPreferenceCheckbox } from './ContactPreferenceCheckbox';
import { ContactPreferenceContent } from './ContactPreferenceContent';
import { selectContactPreferenceUser } from '../selectors';
import { effectContactPreferenceUserSave, effectContactPreferenceUserFetch } from '../effects';
import { useSelector } from '../../redux';
import { useBinding } from '../../shared/useBinding';

export const ContactPreferenceUser: React.FC = () => {
  const [t] = useLocalization('Privacy');
  const dispatch = useDispatch();
  const state = useSelector(selectContactPreferenceUser);
  const ready = useMount(() => state.shouldFetch && dispatch(effectContactPreferenceUserFetch()));

  // Form State
  const [productsOptIn, onProductsOptInChange] = useBinding(state.productsOptIn, (newValue: boolean) => newValue);

  const onSave = useCallback(() => {
    dispatch(effectContactPreferenceUserSave({ productsOptIn: productsOptIn ?? false }));
  }, [productsOptIn]);

  const disabled = !ready || state.readonly;

  return (
    <div>
      {state.disabled && (
        <MessageBar messageBarType={MessageBarType.warning} isMultiline={false}>
          {t('featureTurnedOffMessage')}
        </MessageBar>
      )}
      <ContactPreferenceContent>
        <ContactPreferenceCheckbox
          label={t('contactPreferenceProductsLabel')}
          disabled={disabled}
          checked={productsOptIn}
          onChange={onProductsOptInChange}
        />
        <p>{t('contactPreferenceProductsMessage')}</p>
        <ContactPreferenceFooter activity={state.activity}>
          <PrimaryButton text={t('save')} disabled={disabled} onClick={onSave} />
        </ContactPreferenceFooter>
      </ContactPreferenceContent>
    </div>
  );
};
